import { AllergyReactionDto } from '../Type/AllergyReactionDto'

export default class AllergyRefReaction {
    public constructor(
        public id: number,
        public groupId: number,
        public name: string,
        public stage: number,
        public isActive: boolean,
        public isReferenced?: boolean,
        public _ref_reaction?: boolean,
        public creationDate?: string,
        public updateDate?: string,
        public labelForMenu?: string,
    ) {}

    public toDto(): AllergyReactionDto {
        return {
            id: this.id,
            group_id: this.groupId,
            name: this.name,
            stage: this.stage,
            is_active: this.isActive,
        }
    }
}
